import { Component, inject, signal, computed, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { MessageCatalogService, MessageCatalogItem } from '../../services/message-catalog';
import { PageTitleService } from '../../services/page-title';

@Component({
  selector: 'app-message-catalog',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule],
  templateUrl: './message-catalog.html',
  styleUrls: ['./message-catalog.css'],
})
export class MessageCatalogPage implements OnInit {
  private svc = inject(MessageCatalogService);
  readonly pageTitle = inject(PageTitleService).title;
  private platformId = inject(PLATFORM_ID);

  loading = signal(false);
  items = signal<MessageCatalogItem[]>([]);

  readonly channels = computed(() => this.items().filter((i) => i.category === 'CHANNEL'));
  readonly types = computed(() => this.items().filter((i) => i.category === 'TYPE'));

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.loading.set(true);
    this.svc.getAll().subscribe({
      next: (res: any) => {
        this.loading.set(false);
        const data = res?.data ?? res ?? [];
        this.items.set(Array.isArray(data) ? data : []);
      },
      error: () => this.loading.set(false),
    });
  }
}
